module.exports = __webpack_public_path__ + "img/Welcome2.a9fd5167.png";